export const getApiUrl = (): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const { hostname, origin } = window.location;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // return 'http://10.242.221.0:8888/api';
    return 'https://edtech.rut-miit.ru/api';
  }

  return `${origin}/api`;
};

export const API_URL = getApiUrl();
